var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SearchBox,{attrs:{"filterInputs":_setup.searchCardInputs,"headers":_setup.search_estimate_headers,"handle-search":_setup.searchButton,"search-res-items":_setup.searchRes,"handle-item-click":_setup.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }